/**
 * @description Toggle la recherche
 */

const toggleSearch = () => {
	const search = document.querySelector('.header__right__search') || null;
	if (search) {

		const toggle = search.querySelector('[data-toggle-search]');
		const overlay = search.querySelector('.header__right__search__overlay');
		toggle.addEventListener('click', () => {
			search.getAttribute('data-search') === "close"
				? search.setAttribute('data-search', 'open')
				: search.setAttribute('data-search', 'close');
			overlay.classList.toggle('header__right__search__overlay--open');
			toggle.classList.toggle('btn-search-close');
		})
	}
}

/**
 * @description a11Y keyboard sur la modale de recherche
 */

const keyboardSearch = () => {
	const modalSearch = document.querySelector('.header__right__search') || null;
	const focusableElements =
		'button, input';
	const firstFocusableElement = modalSearch.querySelectorAll(focusableElements)[0] as HTMLElement;
	const focusableContent = modalSearch.querySelectorAll(focusableElements);
	const search = document.querySelector('.header__right__search') || null;
	const lastFocusableElement = focusableContent[focusableContent.length - 1] as HTMLElement;
	const overlay = search.querySelector('.header__right__search__overlay');
	if (modalSearch) {
		modalSearch.addEventListener('keydown', (e: KeyboardEvent) => {

			if (e.key === "Escape") {
				const toggle = search.querySelector('[data-toggle-search]');
				overlay.classList.toggle('header__right__search__overlay--open');
				toggle.classList.toggle('btn-search-close');
			}
		})
	}

}
/**
 * @description Gestion du switchlang
 */

const switchLang = () => {
	const getLang = document.querySelector('.header__right__switchlang') || null;
	if (getLang) { // On vérifie la présence du switchlang

		const btn = document.querySelector('[data-switchlang-toggle]');
		const list = getLang.querySelector('[data-switchlang-list]');
		const els = list.querySelectorAll('[data-switchlang-item]');
		const firstEl = els[0] as HTMLElement;
		let lastEl: any;
		//On determine le dernier élément en fonction de la length de els
		els.length > 1 ? lastEl = els[els.length - 1] : lastEl = firstEl;
		btn.addEventListener('click', () => {
			//On toggle les différentes classes et différents attributs
			btn.classList.toggle('toggle--active')
			list.classList.toggle('list--open');
			let expanded = 'false';
			list.getAttribute('aria-expanded') === 'false' ?
				expanded = 'true' : expanded = 'false';
			list.setAttribute('aria-expanded', expanded);

		})
		//Keyboard interaction du bouton toggle
		btn.addEventListener('keyup', (e: KeyboardEvent) => {
			if (e.key === "Enter" || e.code === "Space") {
				if (list.getAttribute('aria-expanded') === 'true') {
					firstEl.querySelector('a').focus();
				}
			}
		})
		//Keyboard interaction du dernier élément de la liste langue
		lastEl.addEventListener('keydown', (e: KeyboardEvent) => {
			if (e.key === "Tab") {
				btn.classList.remove('toggle--active')
				list.classList.remove('list--open');
				list.setAttribute('aria-expanded', 'false');
			}
		})
	}
}

// Comportement au scroll
const scrollHeader = () => {
	const header = document.querySelector('.header');
	// On detecte sur le body si la wpadminbar est la
	const wpBar = document.querySelector('body').classList.contains('admin-bar');
	document.onscroll = () => {
		if (window.pageYOffset > 40 && document.querySelector('main').offsetHeight > window.innerHeight) {
			header.classList.add('scrolled')
			if (wpBar) { // on ajuste la position du header pour palier a la wpadminbar
				header.classList.add('scrolled-bo')
			}
		} else {
			header.classList.remove('scrolled');
			if (wpBar) {
				header.classList.remove('scrolled-bo')
			}
		}
	}
};

const menuResp = () => {
	const header = document.querySelector('.header');
	const nav = header.querySelector('.main-navigation');
	const menu = nav.querySelector('.menu');
	const toggleMenu = header.querySelector('.toggle-menu');
	const srOnly = toggleMenu.querySelector('[data-toggle-text]');
	const closeTxt = toggleMenu.getAttribute('data-close-label');
	const openTxt = toggleMenu.getAttribute('data-open-label');
	const device = getDevice();
	const switchlang = header.querySelector('.header__right__switchlang') || null;
	const hasChildren = nav.querySelectorAll('.menu-item-has-children');
	if (device === "md" || device === "sm" || device === "xs") {
		//Ajout des boutons des item avec submenu
		hasChildren.forEach(item => {

			const getSubmenu = item.querySelector('.sub-menu');
			const hasToggle = item.querySelector('toggle-submenu') || null;

			if (!hasToggle && getSubmenu) {
				getSubmenu.insertAdjacentHTML('beforebegin', `<button class="toggle-submenu">
				<span class="sr-only">afficher le sous-menu</span>
				</button>`)
			}
		})

		// Création du bouton prev resp
		menu.insertAdjacentHTML('beforebegin', `<button class="menu-resp-prev"></button>`);


		// Gestion du click
		toggleMenu.addEventListener('click', () => {
			document.querySelector('body').classList.toggle('overflow-hidden');
			toggleMenu.classList.toggle('opened')
			nav.classList.toggle('nav--opened');
			nav.querySelector('.menu-resp-prev').classList.remove('menu-resp-prev--opened')
			const openedSubmenus = nav.querySelectorAll('.sub-menu--opened');
			openedSubmenus.forEach(submenu => submenu.classList.remove('sub-menu--opened'))
			console.log(toggleMenu.getAttribute('aria-expanded'));

			if (toggleMenu.getAttribute('aria-expanded') === "false") {
				toggleMenu.setAttribute('aria-expanded', "true");
				srOnly.innerHTML = closeTxt;
			}
			else {
				toggleMenu.setAttribute('aria-expanded', 'false');
				srOnly.innerHTML = openTxt;

			}


		})

		//gestion des sous menus  

		const submenusToggles = nav.querySelectorAll('.toggle-submenu');

		submenusToggles.forEach(btn => {
			btn.addEventListener('click', () => {
				btn.parentNode.querySelector('.sub-menu').classList.add('sub-menu--opened');
				const getParent = btn.parentElement;
				const getText = getParent.querySelector('a').innerText.toLowerCase();
				// Si 1er niveau
				if (!nav.querySelector('.menu-resp-prev').classList.contains('menu-resp-prev--opened')) {
					nav.querySelector('.menu-resp-prev').classList.add('menu-resp-prev--opened')
				}
				nav.querySelector('.menu-resp-prev').innerHTML = getText;
			})
		})

		const btnPrev = nav.querySelector('.menu-resp-prev') || null;

		if (btnPrev) {
			btnPrev.addEventListener('click', () => {
				const openedSubmenus = nav.querySelectorAll('.sub-menu--opened');
				const getText = openedSubmenus[openedSubmenus.length - 1].parentElement.parentElement.parentElement.querySelector('a').innerText;
				openedSubmenus[openedSubmenus.length - 1].classList.remove('sub-menu--opened')
				openedSubmenus.length > 1 ?
					btnPrev.innerHTML = getText.toLowerCase()
					: nav.querySelector('.menu-resp-prev').classList.remove('menu-resp-prev--opened')
			})
		}





		// On déplace le switchlang si il y en a un
		if (switchlang) {
			menu.insertAdjacentElement('beforebegin', switchlang);
		}
	}
	else {
		hasChildren.forEach(item => {
			if (item.querySelector('.toggle-submenu')) {
				item.querySelector('.toggle-submenu').remove();
			}
		})

		// On déplace le switchlan g si il y en a un
		if (switchlang) {
			header.querySelector('.header__right__search').insertAdjacentElement('beforebegin', switchlang);
		}

		if (menu.querySelector('.menu-resp-prev')) {
			menu.querySelector('.menu-resp-prev').remove()
		};
	}
}





const init = () => {
	menuResp();
	scrollHeader();
	switchLang();
	toggleSearch();
	keyboardSearch();

	let resizeId: any;
	window.onresize = () => {
		clearTimeout(resizeId);
		resizeId = setTimeout(doneResizing, 100);
	}

	const doneResizing = () => {
		menuResp();
		scrollHeader();
		switchLang();
		toggleSearch();
	}

}

init(); 